<template>
  <admin-base
    add-btn-text="Add New Domain"
    :add-btn-permission="addDomainPermission"
    @create="create"
    @search="(val) => (search = val)"
  >
    <admin-domains-table
      ref="table"
      :search="search"
      @edit="showDomainModal"
      @delete="showDeleteDomainDialog"
    />
    <domains-modal-form ref="domainModal" @success="refreshTable" />
    <anchor-confirm-dialog
      :title="`Are you sure you want to delete ${domainName} domain?`"
      max-width="500"
      @confirm="deleteDomain"
      @cancel="clearDomain"
      ref="domainDeleteDialog"
    />
  </admin-base>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import AdminBase from '@/components/admin/Base';
import AdminDomainsTable from '@/components/admin/controls/domains/DomainsTable';
import DomainsModalForm from '@/components/admin/controls/domains/form/DomainsModalForm';

export default {
  name: 'AdminControlsDomainsView',
  components: {
    AdminBase,
    AdminDomainsTable,
    DomainsModalForm,
  },
  data: () => ({
    search: null,
    domainToDelete: null,
  }),
  computed: {
    addDomainPermission: vm => vm.$permissions.ADD_DOMAINS,
    domainName: vm => vm.domainToDelete?.name,
  },
  methods: {
    create() {
      this.$refs.domainModal.open();
    },
    showDomainModal() {
      this.$refs.domainModal.open();
    },
    showDeleteDomainDialog(domain) {
      this.$refs.domainDeleteDialog.open();
      this.domainToDelete = domain;
    },
    clearDomain() {
      this.domainToDelete = null;
    },
    refreshTable() {
      this.$refs.table.fetch();
    },
    deleteDomainSuccess() {
      this.$toast.success('Domain successfully deleted!', { timeout: 3000 });
      this.refreshTable();
    },
    deleteDomainFail(message) {
      this.$toast.error(message, { timeout: 3000 });
    },
    deleteDomain() {
      const url = `/v1/domains/${this.domainToDelete._id}`;
      this.$requests
        .delete(url, {})
        .then(() => {
          this.deleteDomainSuccess();
        })
        .catch(e => {
          this.deleteDomainFail(e.response.data?.message || 'Unable to delete domain...');
        });
    },
  },
};
</script>
